import { render } from "./PositiveFit.vue?vue&type=template&id=1a1fa24c&scoped=true&lang=pug"
import script from "./PositiveFit.vue?vue&type=script&lang=js"
export * from "./PositiveFit.vue?vue&type=script&lang=js"

import "./PositiveFit.vue?vue&type=style&index=0&id=1a1fa24c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1fa24c"]])

export default __exports__